// Persistencia de estado puramente visual y temporal (zoom del mapa, vista
// compacta, toggles de mostrar/ocultar) en sessionStorage — nunca datos
// sensibles, nunca respuestas completas de API, nunca formularios. Se usa
// sólo cuando la URL no es el lugar adecuado (serían parámetros que no
// aportan nada al compartir/bookmear un link) y el estado del router no
// alcanza (debe sobrevivir a salir de la pantalla y volver dentro de la
// misma pestaña del navegador). Envuelto en try/catch: en navegación
// privada algunos navegadores lanzan al acceder a sessionStorage.
export function guardarEstadoVisual<T>(clave: string, valor: T): void {
  try {
    sessionStorage.setItem(clave, JSON.stringify(valor));
  } catch {
    // Navegación privada u otra restricción del navegador: se ignora, el
    // estado simplemente no persiste entre pantallas.
  }
}

export function leerEstadoVisual<T>(clave: string, porDefecto: T): T {
  try {
    const guardado = sessionStorage.getItem(clave);
    if (!guardado) return porDefecto;
    return JSON.parse(guardado) as T;
  } catch {
    return porDefecto;
  }
}
